export default "__VITE_ASSET__Dz46feTE__"